import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import {  L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import * as cagregorian from "../node_modules/cldr-data/main/es-MX/ca-gregorian.json";
import * as currencies from "../node_modules/cldr-data/main/es-MX/currencies.json";
import * as numbers from "../node_modules/cldr-data/main/es-MX/numbers.json";
import * as timeZoneNames from "../node_modules/cldr-data/main/es-MX/timeZoneNames.json";
import * as numberingSystems from "../node_modules/cldr-data/supplemental/numberingSystems.json";
import * as LOCALE from '../node_modules/@syncfusion/ej2-locale/src/es.json';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NGaF1cWGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEZjXn1ZcXNRQGJYVEB/Wg==');

function replaceValue(obj) {
  let old_ = JSON.stringify(obj);
  old_ = old_.replace('"es-MX"', '"es"');
  return JSON.parse(old_);
}

let locale = LOCALE;
loadCldr(
  replaceValue(cagregorian),
  replaceValue(currencies),
  replaceValue(numbers),
  replaceValue(timeZoneNames),
  numberingSystems
);

L10n.load({ es: locale["es"] });
setCulture("es");

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
